// QR Kiosk v2 — shared 24h "HH:mm" formatter (KV2-5). Extracted verbatim from the
// KV2-0 OfflineStrip local `formatTime` so it now has two consumers (OfflineStrip +
// CachedErrorState) with ONE implementation. Zero-padded, matches the platform
// DD.MM.YYYY, HH:mm time family. No deps, no Date objects escape.
export function formatClockTime(epochMs: number): string {
  const d = new Date(epochMs);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
}

export default formatClockTime;
